module.exports = __webpack_public_path__ + "static/media/product-4.cb9ed06b.jpg";